import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { QRCodeSVG } from 'qrcode.react'

const Barcode = () => {
  const [productMstList, setProductMstList] = useState([]);

  useEffect(() => {
    const decodeArray = JSON.parse(decodeURIComponent(localStorage.getItem('productList')));

    decodeArray.map(v => {
      v.qrCode = v.productSeq?.toString();
      v.type = v.productType;
      v.categoryName = v.productKind;
      v.warehousing = v.regDate?.split(' ')?.[0];
    });

    setProductMstList(decodeArray);

    const url = window.location.protocol + '//' + window.location.host + window.location.pathname;

    window.history.replaceState({ path: url }, '', url);
  }, []);

  return (
    <>
      {productMstList?.map((item, idx) => (
        <BarcodeFormContainer>
          <BarcodeForm>
            <tr>
              <th>Product</th>
              <td>
                {item.productName}
              </td>
              <td><QRCodeSVG value={item.qrCode} size={64}/></td>
            </tr>
            <tr>
              <th>Category</th>
              <td colSpan={2}>{item.categoryName}</td>
            </tr>
            <tr>
              <th>Type</th>
              <td colSpan={2}>{item.type}</td>
            </tr>
            <tr>
              <th>Warehousing</th>
              <td colSpan={2}>{item.warehousing}</td>
            </tr>
          </BarcodeForm>
        </BarcodeFormContainer>
      ))}
    </>
  )
}

const BarcodeFormContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 0 370px 0;
  padding-top: 10px;
`;

const BarcodeForm = styled.table`
  width: 40%;
  border-collapse: collapse;

  & th {
    border: 1px solid #000;
    padding: 8px;
    text-align: center;
    vertical-align: middle;
  }

  & td {
    border: 1px solid #000;
    padding: 8px;
    text-align: center;
    vertical-align: middle;
    line-height: 16px;
  }
`;

export default Barcode;